import Swiper from "swiper/dist/js/swiper.js";
import $ from 'jquery/dist/jquery.js';

export default {
    init() {

        $(document).ready(console.log('testing'));

        function load_posts(search='', page=1, category=[])
        {
            $.ajax({
                url: 'posts/v2/posts/',
                type: 'GET',
                data: {
                    number_of_posts: 10,
                    search,
                    page,
                    category
                },
                success: function(res) {
                    $('#blog-section').children().remove();
                    $('#blog-section').append(res.posts);

                    console.log(res.posts);

                    document.body.scrollTop = document.documentElement.scrollTop = 0;
                }
            });
        }

        function get_cats() {
            let cat = [];

            $('#news-filters > li > a').each(function() {
                if ($(this).hasClass('active')) {
                    cat.push($(this).attr('data-cat'));
                }
            });

            return cat;
        }

        function get_current_page() {
            const current_elem = parseInt($('span.current').text());

            return (!isNaN(current_elem)) ? parseInt(current_elem) : 1;
        }

        //load_posts();

        $('#news-filters > li > a').on('click', function(e) {
            e.preventDefault();

            let cat = $(this).attr('data-cat');
            let page = 1;
            let search = $('#news-search').val();

            $('#news-filters > li > a').each(function() {
                if ($(this).attr('data-cat') !== cat) {
                    $(this).removeClass('active');
                } else {
                    $(this).addClass('active');
                }
            });

            cat = [cat];
            load_posts(search, page, cat);
        });

        $('#news-s').on('submit', function(e) {
            e.preventDefault();
            document.activeElement.blur();

            let cat = get_cats();
            let page = 1;
            let search = $('#news-search').val();


            load_posts(search, page, cat);
        });

        $(document).on('click', 'a.page-numbers', function(e) {
            e.preventDefault();

            let cat = get_cats();
            let page = parseInt($(this).text());
            let search = $('#news-search').val();

            load_posts(search, page, cat);
        });

        $(document).on('click', 'a.prev', function(e) {
            e.preventDefault();

            let cat = get_cats();
            let page = get_current_page() - 1;
            let search = $('#news-search').val();

            load_posts(search, page, cat);
        });

        $(document).on('click', 'a.next', function(e) {
            e.preventDefault();

            let cat = get_cats();
            let page = get_current_page() + 1;
            let search = $('#news-search').val();

            load_posts(search, page, cat);
        });

    },
    finalize() {
        // JavaScript to be fired on the home page, after the init JS
    },
};
